// Arabic module 08 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enVerification } from './en-verification.ts';
import type { Message } from './types.ts';

export const arVerification: { readonly [K in keyof typeof enVerification]: Message } = {
  'ver.api.replaceConfirm': 'لدى هذا الشخص إثبات هوية مقبول لهذه الزيارة. أكّد أن الالتقاط الجديد يجب أن يحل محله.',
  'ver.api.transition': 'لا يمكن نقل إثبات الهوية من «{from}» إلى «{to}».',
  'ver.api.superseded': 'تم استبدال هذا السجل بإثبات أحدث. افتح السجل الحالي.',
  'ver.api.notReviewable': 'هذا السجل لا ينتظر المراجعة.',
  'ver.api.documentExpired': 'انتهت صلاحية الوثيقة. لا يمكن قبولها.',
  'ver.api.ownCapture': 'أنت من التقط هذا السجل ويحتاج إلى مراجع ثانٍ. اطلب من مُتحقق آخر اتخاذ القرار.',
  'ver.api.ownCorrection': 'أنت من صحّح هذا السجل ويحتاج إلى مراجع ثانٍ. اطلب من مُتحقق آخر اتخاذ القرار.',
  'ver.api.unscannedDocument': 'لا يتوفر فحص للبرمجيات الضارة لهذا الملف. اقبله فقط بعد رؤية الوثيقة الأصلية شخصيًا، أو ارفضه.',
  'ver.api.imageDecisionRequired': 'ما زالت هناك صور هوية محفوظة. اختر ما سيحدث لها قبل إيقاف حفظ الصور.',
  'ver.api.notEntitled': 'خدمة الهوية الرقمية (UAE PASS) ليست ضمن باقة هذه المؤسسة.',
  'ver.api.methodUnavailable': 'طريقة التحقق هذه غير متاحة لهذه الزيارة.',
  'ver.api.signingUnavailable': 'التوقيع عبر UAE PASS غير مفعّل.',
  'ver.api.alreadyVerified': 'تم التحقق من هويتك بالفعل لهذه الزيارة.',
  'ver.api.providerNotActive': 'خدمة UAE PASS غير متاحة الآن. يُرجى التحقق من هويتك لدى الاستقبال.',
  'ver.api.scopeNotApproved': 'نطاق UAE PASS المطلوب غير معتمد.',
  'ver.api.transactionUnknown': 'رابط التحقق هذا غير صالح في هذا المتصفح. ابدأ من جديد من تصريح الزيارة.',
  'ver.api.transactionFinished': 'انتهت محاولة التحقق هذه بالفعل.',
  'ver.api.secretMissing': 'أدخل السر الخاص بالعميل لهذه البيئة أولًا.',
  'ver.api.onboardingIncomplete': 'لا يمكن تفعيل بيئة الإنتاج قبل تسجيل جميع موافقات الانضمام.',
  'ver.api.goLiveSelfApproved': 'يجب أن يسجّل مسؤول آخر موافقة بدء التشغيل.',
  'rcp.blocker.identity_verification_required': 'الهوية الموثّقة مطلوبة لفئة الزائر هذه ولم تكتمل بعد.',
  'rcp.warning.identity_evidence_missing': 'لا يوجد تحقق مقبول من الهوية بعد (غير مطلوب لهذه الفئة).',

  'ver.v.consentRequired': 'أكّد موافقتك على مشاركة هذه البيانات.',
  'ver.v.typeNotAllowedHere': 'نوع الوثيقة هذا غير مقبول في هذا الموقع.',
  'ver.v.typeUnknown': 'اختر نوع وثيقة مُعدًّا، أو «وثيقة أخرى».',
  'ver.v.mrz.invalid_characters': 'تحتوي المنطقة المقروءة آليًا على أحرف غير مسموح بها.',
  'ver.v.mrz.unsupported_format': 'أدخل سطرين من 44 حرفًا (جواز سفر) أو ثلاثة أسطر من 30 حرفًا (بطاقة هوية).',
  'ver.v.methodDisabled': 'هذه الطريقة متوقفة في إعدادات التحقق.',
  'ver.v.adapterUnknown': 'هذا الجهاز أو المحوّل غير متاح.',
  'ver.v.reasonUnsupported': 'اذكر سبب استخدام نوع وثيقة غير مُعدّ.',
  'ver.v.numberInvalid': 'رقم الوثيقة لا يجتاز فحوصات هذا النوع من الوثائق.',
  'ver.v.nothingToCorrect': 'غيّر حقلًا مسموحًا واحدًا على الأقل.',
  'ver.v.reasonOtherJurisdiction': 'اذكر سببًا: هذا الملف من بلد إصدار آخر.',
  'ver.v.settings.duplicate': 'هذا الرمز مستخدم مرتين.',
  'ver.v.settings.unknown_validator': 'أداة تحقق غير معروفة.',
  'ver.v.settings.validator_mismatch': 'أداة التحقق هذه تخص بلدًا آخر.',
  'ver.v.settings.jurisdiction': 'استخدم رمز بلد من حرفين، أو * لأي بلد.',
  'ver.v.settings.sealed_not_allowed': 'لا يمكن حفظ هذا الحقل.',
  'ver.v.settings.unknownSite': 'أحد المواقع المختارة غير موجود.',
  'ver.v.scopeNotApproved': 'يمكن طلب نطاقات المصادقة المعتمدة فقط.',
  'ver.v.ackNotSignable': 'يمكن التوقيع عبر UAE PASS على إقرار وقّعته وقبلته فقط.',

  'ver.sim.title': 'محاكي UAE PASS (للتطوير)',
  'ver.sim.notice': 'هذا محاكٍ محلي. لا يُستخدم أي حساب أو هوية حقيقية في UAE PASS.',
  'ver.sim.scopes': 'النطاقات المطلوبة',
  'ver.sim.approveVerified': 'الموافقة كحساب تجريبي موثّق',
  'ver.sim.approveBasic': 'الموافقة كحساب تجريبي أساسي (غير موثّق)',
  'ver.sim.timeout': 'محاكاة انتهاء مهلة مزوّد الخدمة',
  'ver.sim.cancel': 'إلغاء تسجيل الدخول',

  'nav.identity': 'التحقق من الهوية',
  'ver.method.uae_pass': 'الهوية الرقمية (UAE PASS)',
  'ver.method.emirates_id_reader': 'قارئ بطاقة الهوية الإماراتية',
  'ver.method.passport_mrz': 'المنطقة المقروءة آليًا لجواز السفر أو الهوية',
  'ver.method.document_ocr': 'مسح الوثيقة (التعرف الضوئي)',
  'ver.method.manual': 'تحقق يدوي من قبل مُتحقق',
  'ver.level.none': 'غير مطلوب',
  'ver.level.warn': 'مستحسن (تنبيه فقط)',
  'ver.level.required': 'مطلوب قبل الوصول',
  'ver.proof.identity': 'الهوية',
  'ver.proof.nationality': 'الجنسية',
  'ver.proof.work_authorisation': 'تصريح العمل',
  'ver.attr.given_name': 'الاسم الأول',
  'ver.attr.family_name': 'اسم العائلة',
  'ver.attr.full_name_ar': 'الاسم بالعربية',
  'ver.attr.document_number': 'رقم الوثيقة',
  'ver.attr.document_type': 'نوع الوثيقة',
  'ver.attr.issuing_country': 'بلد الإصدار',
  'ver.attr.nationality': 'الجنسية',
  'ver.attr.date_of_birth': 'تاريخ الميلاد',
  'ver.attr.sex': 'الجنس',
  'ver.attr.expiry_date': 'تاريخ الانتهاء',
  'ver.attr.provider_subject': 'معرّف حساب UAE PASS',
  'ver.attr.assurance_level': 'مستوى حساب UAE PASS',
  'ver.attr.mobile': 'رقم الهاتف المتحرك',
  'ver.attr.email': 'البريد الإلكتروني',
  'ver.attr.unrecognised': 'حقول غير معروفة',
  'ver.reason.unreadable': 'تعذّرت القراءة',
  'ver.reason.timeout': 'لم يستجب الجهاز',
  'ver.reason.unsupported_type': 'نوع الوثيقة غير مُعدّ',
  'ver.reason.format_invalid': 'صيغة الرقم غير صالحة',
  'ver.reason.check_digit_invalid': 'رقم التحقق غير صالح',
  'ver.reason.document_expired': 'الوثيقة منتهية الصلاحية',
  'ver.reason.corrected': 'حقول صحّحها شخص',
  'ver.reason.rules_unconfirmed': 'فحص الصيغة فقط (القواعد غير مؤكدة)',
  'ver.reason.assurance_below_minimum': 'مستوى حساب UAE PASS أقل من الحد الأدنى',
  'ver.reason.identity_relevant_change': 'تغيّر الاسم بعد التحقق',
  'ver.check.valid': 'صالح',
  'ver.check.invalid': 'غير صالح',
  'ver.check.not_applicable': 'لا ينطبق',
  'ver.check.expired': 'منتهي',
  'ver.check.unknown': 'غير معروف',
  'ver.check.confirmed': 'قواعد مؤكدة',
  'ver.check.format_only_unconfirmed': 'فحص الصيغة فقط',
  'ver.tx.started': 'قيد التنفيذ',
  'ver.tx.completed': 'مكتمل',
  'ver.tx.cancelled': 'ملغى',
  'ver.tx.failed': 'فشل',
  'ver.tx.expired': 'منتهي',
  'ver.tx.unknown': 'النتيجة غير معروفة',
  'ver.limit.not_work_permit': 'ليست تصريح عمل',
  'ver.limit.not_nationality_proof': 'ليست إثباتًا للجنسية',
  'ver.limit.unsupported_document_type': 'نوع الوثيقة غير مُعدّ',
  'ver.match.document': 'الوثيقة نفسها',
  'ver.match.name_and_jurisdiction': 'الاسم نفسه وبلد الإصدار نفسه',
  'ver.match.name_other_jurisdiction': 'الاسم نفسه وبلد إصدار مختلف — يبقى منفصلًا حتى المراجعة',
  'ver.match.linked': 'مرتبط',
  'ver.match.kept_separate': 'منفصل',
  'ver.doc.content_reviewed': 'تمت مراجعة المحتوى',
  'ver.doc.original_sighted': 'تمت رؤية الأصل شخصيًا',

  'ver.ui.title': 'التحقق من الهوية',
  'ver.ui.sub': 'الهوية واقعة مستقلة. لا تغيّر الموافقة أو الحضور أو صلاحية الدخول.',
  'ver.ui.requirement': 'هذه الفئة: {level}',
  'ver.ui.satisfied': 'متطلب الهوية مستوفى',
  'ver.ui.notSatisfied': 'متطلب الهوية غير مستوفى',
  'ver.ui.shortfall.method_not_accepted': 'مقبول، لكن هذه الطريقة غير مقبولة لفئة الزائر.',
  'ver.ui.shortfall.proof_missing': 'مقبول، لكن هذه الوثيقة لا تثبت ما تحتاجه الفئة.',
  'ver.ui.none': 'لم يُسجَّل إثبات هوية بعد.',
  'ver.ui.current': 'الإثبات الحالي',
  'ver.ui.previous': 'سجلات سابقة ({n})',
  'ver.ui.method': 'الطريقة',
  'ver.ui.document': 'الوثيقة',
  'ver.ui.number': 'الرقم',
  'ver.ui.expires': 'تنتهي في',
  'ver.ui.checks': 'الفحوصات',
  'ver.ui.checkFormat': 'الصيغة',
  'ver.ui.checkDigits': 'أرقام التحقق',
  'ver.ui.checkExpiry': 'الصلاحية',
  'ver.ui.ruleStatus': 'القواعد',
  'ver.ui.proves': 'تثبت',
  'ver.ui.limitations': 'القيود',
  'ver.ui.provenance': 'المصدر',
  'ver.ui.device': '{model} · البرنامج الثابت {firmware}',
  'ver.ui.firmwareUnvalidated': 'البرنامج الثابت غير مُعتمد',
  'ver.ui.simulator': 'محاكٍ',
  'ver.ui.imageDiscarded': 'لم تُحفظ الصورة (وفق السياسة)',
  'ver.ui.imageStored': 'حُفظت الصورة وفق سياسة الصور',
  'ver.ui.discarded': 'حُذف قبل الحفظ: {fields}',
  'ver.ui.corrected': 'صحّحها شخص: {fields}',
  'ver.ui.secondReviewer': 'يحتاج إلى مُتحقق ثانٍ',
  'ver.ui.history': 'السجل',
  'ver.ui.capturedBy': 'التقطه {name}',
  'ver.ui.capturedByProvider': 'وارد من مزوّد الخدمة',
  'ver.ui.decidedBy': 'قرّره {name}',
  'ver.ui.decidedBySystem': 'قُبل تلقائيًا وفق السياسة',
  'ver.ui.capture': 'التقاط وثيقة',
  'ver.ui.captureHint': 'يسجّل الالتقاط ما قرأه الجهاز ليراجعه مُتحقق. ولا يُعد بحد ذاته نتيجة تحقق.',
  'ver.ui.adapter': 'الجهاز أو المصدر',
  'ver.ui.scenario': 'نتيجة المحاكي',
  'ver.ui.scenario.valid': 'وثيقة مقروءة',
  'ver.ui.scenario.unreadable': 'شريحة أو صورة غير مقروءة',
  'ver.ui.scenario.expired': 'وثيقة منتهية الصلاحية',
  'ver.ui.scenario.bad_check_digit': 'رقم تحقق خاطئ',
  'ver.ui.scenario.timeout': 'الجهاز لا يستجيب',
  'ver.ui.mrz': 'المنطقة المقروءة آليًا',
  'ver.ui.mrzHint': 'سطران من 44 حرفًا (جواز سفر) أو ثلاثة أسطر من 30 حرفًا (بطاقة هوية). يمكن لماسح يدوي كتابتها هنا.',
  'ver.ui.documentType': 'نوع الوثيقة',
  'ver.ui.otherType': 'وثيقة أخرى (غير مُعدّة)',
  'ver.ui.replaceCurrent': 'استبدال الإثبات المقبول بهذا السجل الجديد',
  'ver.ui.captureSubmit': 'تسجيل الالتقاط',
  'ver.ui.manual': 'تحقق يدوي',
  'ver.ui.manualHint': 'سجّل ما تحققت منه عندما لا يتوفر التحقق الإلكتروني أو لا يكون مطلوبًا. يسجّل المُتحققون فقط النتيجة.',
  'ver.ui.observedGiven': 'الاسم الأول كما في الوثيقة',
  'ver.ui.observedFamily': 'اسم العائلة كما في الوثيقة',
  'ver.ui.observedNumber': 'رقم الوثيقة',
  'ver.ui.observedExpiry': 'تاريخ الانتهاء',
  'ver.ui.jurisdiction': 'بلد الإصدار (حرفان)',
  'ver.ui.outcome': 'النتيجة',
  'ver.ui.outcome.verified': 'تم التحقق',
  'ver.ui.outcome.rejected': 'مرفوض',
  'ver.ui.outcome.unavailable': 'تعذّر التحقق',
  'ver.ui.reason': 'السبب',
  'ver.ui.manualSubmit': 'تسجيل التحقق',
  'ver.ui.decide': 'قرار المراجعة',
  'ver.ui.accept': 'قبول',
  'ver.ui.reject': 'رفض',
  'ver.ui.unavailable': 'وضع علامة «غير متاح»',
  'ver.ui.correct': 'تصحيح الحقول',
  'ver.ui.correctHint': 'تُعلَّم التصحيحات على السجل. وفق الإعدادات الافتراضية يجب أن يقبل مُتحقق آخر السجل المصحّح.',
  'ver.ui.correctSubmit': 'حفظ التصحيحات',
  'ver.ui.reveal': 'إظهار الرقم كاملًا',
  'ver.ui.revealReason': 'لماذا تحتاج إلى الرقم الكامل؟',
  'ver.ui.revealed': 'الرقم الكامل (يُعرض مرة واحدة ويُسجَّل في سجل التدقيق)',
  'ver.ui.hide': 'إخفاء',
  'ver.ui.matches': 'ملفات قائمة محتملة',
  'ver.ui.matchesHint': 'اقتراحات فقط. تشابه الأسماء أو بيانات الاتصال ليس إثباتًا للهوية؛ لا يُربط شيء حتى تؤكد.',
  'ver.ui.findMatches': 'البحث عن ملفات مطابقة',
  'ver.ui.noMatches': 'لا توجد ملفات مطابقة يمكنك رؤيتها.',
  'ver.ui.lastVisit': 'آخر زيارة {date}',
  'ver.ui.link': 'ربط كالشخص نفسه',
  'ver.ui.separate': 'إبقاء منفصلًا',
  'ver.ui.documents': 'وثائق الزائر',
  'ver.ui.documentsHint': 'رُفعت قبل الزيارة وهي محجوزة. يُسجَّل فتح أي منها في سجل التدقيق.',
  'ver.ui.open': 'فتح',
  'ver.ui.reviewMethod': 'كيف راجعتها؟',
  'ver.ui.transactions': 'محاولات UAE PASS',
  'ver.ui.image': 'عرض الصورة',

  'ver.page.eyebrow': 'الإدارة',
  'ver.page.intro': 'اعتمد على مصدر الإثبات وصلاحيته وحكم المراجع — لا على نجاح الرفع.',
  'ver.tab.queue': 'قائمة المراجعة',
  'ver.tab.settings': 'الإعدادات',
  'ver.tab.uaepass': 'UAE PASS',
  'ver.queue.empty': 'لا يوجد شيء بانتظار مراجعة الهوية.',
  'ver.queue.visitor': 'الزائر',
  'ver.queue.item': 'الإثبات',
  'ver.queue.status': 'الحالة',
  'ver.queue.received': 'تاريخ الاستلام',
  'ver.queue.review': 'مراجعة',
  'ver.queue.kind.evidence': 'سجل هوية',
  'ver.queue.kind.document': 'وثيقة مرفوعة',
  'ver.set.methods': 'طرق التحقق',
  'ver.set.methodsHint': 'التحقق اليدوي من قبل مُتحقق متاح دائمًا.',
  'ver.set.types': 'أنواع الوثائق',
  'ver.set.typesHint': 'يستخدم كل نوع أداة تحقق خاصة به ذات إصدار. لا تُطبَّق قواعد الهوية الإماراتية أبدًا على وثيقة بلد آخر.',
  'ver.set.type.code': 'الرمز',
  'ver.set.type.label': 'الاسم',
  'ver.set.type.kind': 'النوع',
  'ver.set.type.jurisdiction': 'البلد',
  'ver.set.type.validator': 'أداة التحقق',
  'ver.set.type.proves': 'تثبت',
  'ver.set.type.enabled': 'مفعّل',
  'ver.set.type.sites': 'المواقع',
  'ver.set.type.allSites': 'جميع المواقع',
  'ver.set.type.noSites': 'لا يوجد موقع بعد',
  'ver.set.type.autoVerify': 'القبول تلقائيًا عند اجتياز جميع الفحوصات',
  'ver.set.kind.national_id': 'هوية وطنية',
  'ver.set.kind.passport': 'جواز سفر',
  'ver.set.kind.driving_licence': 'رخصة قيادة',
  'ver.set.kind.residence_permit': 'تصريح إقامة',
  'ver.set.extraction': 'الحقول المحفوظة',
  'ver.set.extractionHint': 'تُحفظ هذه الحقول فقط للغرض أدناه. أي حقل آخر تعيده الوثيقة أو مزوّد الخدمة يُحذف قبل الحفظ ولا يُسجَّل أبدًا.',
  'ver.set.purpose': 'الغرض',
  'ver.set.discardedPreview': 'المحذوف: {fields}',
  'ver.set.images': 'صور وثائق الهوية',
  'ver.set.imagesHint': 'متوقفة افتراضيًا. عند تفعيلها تُحفظ الصور في تخزين محمي ولا يفتحها إلا المُتحققون.',
  'ver.set.imagesStore': 'حفظ صور وثائق الهوية',
  'ver.set.retentionClass': 'فئة الاحتفاظ',
  'ver.set.retentionDays': 'مدة الاحتفاظ (أيام)',
  'ver.set.retentionUndecided': 'لم تُحدَّد مدة الاحتفاظ',
  'ver.set.heldImages': '{n} صورة محفوظة.',
  'ver.set.heldDecision': 'ماذا يجب أن يحدث للصور المحفوظة حاليًا؟',
  'ver.set.held.retain_until_retention': 'الاحتفاظ بها حتى انتهاء مدة الاحتفاظ',
  'ver.set.held.request_disposal': 'طلب التخلص منها الآن (تنفذه إجراءات الخصوصية)',
  'ver.set.review': 'قواعد المراجعة',
  'ver.set.secondCorrections': 'يجب أن يقبل مُتحقق مختلف السجلات المصحّحة',
  'ver.set.secondManual': 'يجب أن يؤكد مُتحقق مختلف عمليات التحقق اليدوي',
  'ver.set.unscanned': 'السماح بقبول الوثائق المرفوعة التي تعذّر فحصها من البرمجيات الضارة بعد مراجعة محتواها',
  'ver.set.uaepass': 'نتائج UAE PASS',
  'ver.set.autoAccept': 'قبول الهويات الموثّقة من مزوّد الخدمة تلقائيًا',
  'ver.set.minimumAssurance': 'الحد الأدنى لمستوى حساب UAE PASS',
  'ver.set.signing': 'السماح بتوقيع الوثائق عبر UAE PASS',
  'ver.set.evidenceRetention': 'الاحتفاظ بإثباتات الهوية لمدة (أيام)',
  'ver.set.saved': 'تم حفظ إعدادات التحقق.',
  'ver.set.adapters': 'الأجهزة والمحوّلات',
  'ver.set.adaptersHint': 'لم يُختر بعد جهاز قارئ أو مزوّد للتعرف الضوئي. المحاكيات محلية ولا تتحقق أبدًا من شخص حقيقي.',
  'ver.up.notEntitled': 'خدمة UAE PASS ليست ضمن باقة هذه المؤسسة. تبقى الإعدادات ظاهرة ليتمكن المسؤول من إيقاف ما هو موجود.',
  'ver.up.environments': 'البيئات',
  'ver.up.environmentsHint': 'تستخدم بيئتا الاختبار والإنتاج بيانات اعتماد منفصلة. الأسرار للكتابة فقط.',
  'ver.up.environment': 'البيئة',
  'ver.up.env.staging': 'الاختبار',
  'ver.up.env.production': 'الإنتاج',
  'ver.up.adapter': 'المحوّل',
  'ver.up.issuer': 'الجهة المُصدِرة',
  'ver.up.clientId': 'معرّف العميل',
  'ver.up.clientSecret': 'سر العميل',
  'ver.up.secretSet': 'يوجد سر محفوظ. اترك الحقل فارغًا للإبقاء عليه.',
  'ver.up.scopes': 'نطاقات المصادقة',
  'ver.up.scopesHint': 'يُطلب التحقق من الهوية فقط. التوقيع والختم الإلكتروني ومشاركة الوثائق منفصلة ومتوقفة.',
  'ver.up.save': 'حفظ البيئة',
  'ver.up.activate': 'استخدام هذه البيئة',
  'ver.up.disable': 'إيقاف',
  'ver.up.disableReason': 'سبب الإيقاف',
  'ver.up.status.configured': 'مُعدّة',
  'ver.up.status.active': 'قيد الاستخدام',
  'ver.up.status.disabled': 'متوقفة',
  'ver.up.notConfigured': 'غير مُعدّة',
  'ver.up.onboarding': 'الانضمام لبيئة الإنتاج',
  'ver.up.onboardingHint': 'تحتاج بيئة الإنتاج إلى موافقة مزوّد الخدمة والاتفاقية وتقييم اختبار ناجح وموافقة بدء تشغيل من مسؤول آخر.',
  'ver.up.item.service_provider_approval': 'موافقة مزوّد الخدمة',
  'ver.up.item.agreement': 'الاتفاقية',
  'ver.up.item.staging_assessment': 'تقييم بيئة الاختبار',
  'ver.up.item.go_live_approval': 'موافقة بدء التشغيل',
  'ver.up.outcome.approved': 'موافق عليه',
  'ver.up.outcome.passed': 'ناجح',
  'ver.up.outcome.signed': 'موقّع',
  'ver.up.outcome.rejected': 'مرفوض',
  'ver.up.outcome.failed': 'فاشل',
  'ver.up.reference': 'المرجع',
  'ver.up.note': 'ملاحظة',
  'ver.up.record': 'تسجيل',
  'ver.up.gateOk': 'يمكن تفعيل بيئة الإنتاج.',
  'ver.up.gateMissing': 'ما زال مطلوبًا للإنتاج: {items}',
  'ver.up.gateSelf': 'سجّلت أنت موافقة بدء التشغيل؛ يجب أن يفعّل مسؤول آخر بيئة الإنتاج.',
  'ver.up.recordedBy': '{name}، {date}',

  'ver.pass.title': 'تحقق من هويتك',
  'ver.pass.required': 'تحتاج زيارتك إلى هوية موثّقة قبل الوصول.',
  'ver.pass.optional': 'يمكنك التحقق من هويتك الآن لتوفير الوقت لدى الاستقبال.',
  'ver.pass.verified': 'تم التحقق من هويتك.',
  'ver.pass.review': 'بياناتك لدى مُتحقق للمراجعة.',
  'ver.pass.consent': 'أوافق على مشاركة اسمي وبيانات هويتي الإماراتية من UAE PASS مع هذه المؤسسة لغرض: {purpose}.',
  'ver.pass.start': 'التحقق عبر UAE PASS',
  'ver.pass.starting': 'جارٍ فتح UAE PASS…',
  'ver.pass.assisted': 'يمكنك أيضًا إبراز وثيقة هوية لدى الاستقبال.',
  'ver.pass.pending': 'ما زالت هناك محاولة UAE PASS مفتوحة. يمكنك البدء من جديد.',
  'ver.ret.title': 'التحقق من الهوية',
  'ver.ret.working': 'جارٍ التحقق من النتيجة…',
  'ver.ret.verified': 'تم التحقق من هويتك. يمكنك إغلاق هذه الصفحة أو العودة إلى تصريح الزيارة.',
  'ver.ret.review_pending': 'تسلمنا بياناتك. سيراجعها مُتحقق قبل زيارتك.',
  'ver.ret.cancelled': 'ألغيت تسجيل الدخول إلى UAE PASS. لم يتم التحقق من هويتك بعد؛ ولا تتأثر زيارتك.',
  'ver.ret.failed': 'تعذّر التحقق من هويتك هذه المرة. يمكنك المحاولة مجددًا أو التحقق لدى الاستقبال.',
  'ver.ret.unknown': 'لم تستجب خدمة UAE PASS في الوقت المحدد. لم يتم التحقق من هويتك بعد؛ يمكنك المحاولة مجددًا أو التحقق لدى الاستقبال.',
  'ver.ret.signed': 'تم توقيع وثيقتك عبر UAE PASS.',
  'ver.ret.back': 'العودة إلى تصريح الزيارة',

  'ver.pol.title': 'التحقق من الهوية',
  'ver.pol.hint': 'مدى صرامة الاستقبال والكشك في التعامل مع الهوية لهذه الفئة.',
  'ver.pol.level': 'المتطلب',
  'ver.pol.methods': 'الطرق المقبولة',
  'ver.pol.proofs': 'يجب أن تثبت',
};
